<template lang="html">
  <div class="listing-row" @click="onClick">
    <div class="flex-box section-field">
      <div>
        <img :src="listing.profile_image_url" class="profile-image">
      </div>

      <div class="listing-detail body-17 gray">
        <div class="bold black">
          {{listing.vendor_name}}
        </div>
        <div>
          {{listing.name}}
        </div>
        <div>
          {{listing.area}} sqft
        </div>
        <div v-for="rooms in roomsList" class="desktop-only" :key="rooms">
          {{rooms}}
        </div>
        <div class="modified-at body-14 desktop-only gray">
          Modified on {{formattedUpdatedAt(listing.updated_at)}}
        </div>
      </div>

      <div class="status-group">
        <div>
          <SymbiumButton
            :text="listing.status"
            :loading="false"
            :isSmall="true"
            :isDialog="listing.status !== 'Active Listing'"
          />
        </div>
        <div class="body-14 mobile-only gray">
          <div class="gap-1x" />
          Modified on {{formattedUpdatedAt(listing.updated_at)}}
        </div>
      </div>
    </div>
  </div>

</template>

<script>
import _ from 'lodash';
import moment from 'moment'
import SymbiumButton from 'src/components/common/SymbiumButton.vue'

export default {
  components: {SymbiumButton},
  props: ['listing', 'onClick'],
  methods: {
    formattedUpdatedAt(updatedAt) {
      return moment(updatedAt).format('LL')
    }
  },
  computed: {
    roomsList() {
      if(!Array.isArray(this.listing.rooms)) return ''
      var rooms = this.listing.rooms;
      if (this.listing.bedroom && this.listing.bedroom > 0) {
        rooms.push(`${this.listing.bedroom} Bed`)
      }
      if (this.listing.bathroom && this.listing.bathroom > 0) {
        rooms.push(`${this.listing.bathroom} Bath`)
      }
      var roomsGroup = _.chunk(rooms, 2);
      return _.map(roomsGroup, (room) => {
        return room.join(' · ')
      })
    },
  }
}
</script>

<style lang="scss" scoped>
.listing-row {
  cursor: pointer;

  .section-field {
    padding: 32px 0;
  }

  .profile-image {
    width: 252px;
    min-height: 168px;
  }

  .listing-detail {
    margin-left: 48px;
    flex-grow: 1;
    position: relative;
    display: flex;
    flex-wrap: wrap;
    flex-direction: column;

    .modified-at {
      margin-top: auto;
    }
  }

  @media screen and (max-width: 768px) {
    .profile-image {
      width: 168px;
      min-height: 113px;
    }

    .section-field {
      padding: 24px 0;
      display: flex;
      flex-wrap: wrap;
    }

    .listing-detail {
      margin-left: 24px;
      width: calc(100% - 192px);
      max-height: 94px;
      overflow-y: scroll;
    }

    .status-group {
      margin-left: 190px;
    }

    .listing-detail {
      display: block;
    }
  }
}
</style>
